<template>
    <div class='ce'>
      <div>
        <span class="ce__title">Column Editor</span>
      </div>
      <div class="ce__row">
        <div>
          <div>
            <input type="checkbox"
                v-model="allSelected"
                @change="selectAll(!allSelected)"
                id="select-all-checkbox"
                />
                <label class="ce__checkbox-label" for="select-all-checkbox">Select All</label>
          </div>
        </div>
      </div>
      <div class="ce__row">
        <div class="ce__column">
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">Strategy</label>
            </div>
            <div v-for="(column, i) in strategy" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label" :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
            </div>
          </div>
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">Ranking Data</label>
            </div>
            <div v-for="(column, i) in rankingData" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label" :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
            </div>
          </div>
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">Baseline Data</label>
            </div>
            <div v-for="(column, i) in baselineData" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label" :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
              </div>
          </div>
        </div>
        <div class="ce__column">
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">SERP Features</label>
            </div>
            <div v-for="(column, i) in serpFeatures" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label"  :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
            </div>
          </div>
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">Search Volume</label>
            </div>
            <div v-for="(column, i) in searchVolume" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label" :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
            </div>
          </div>
          <div>
            <div class="ce__label-wrapper">
              <label class="ce__label">Product Grids</label>
            </div>
            <div v-for="(column, i) in productGrids" :key="i">
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                <label class="ce__checkbox-label" :for="column._column.field + '_column_checkbox'">{{ column._column.definition.title }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="ce__row">
        <div class="ce__controls">
          <button class="ce__button ce__button_cancel"
                  @click="close()">
            Close
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'ColumnEditor',
  mixins: [BaseModalMixins],
  props: {
    columns: Array
  },
  data () {
    return {
      allSelected: this.columns.every(column => column._column.visible)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggle (field) {
      this.$emit('toggle', field)
      this.allSelected = this.columns.every(column => column._column.visible)
    },
    selectAll (bool) {
      if (!bool) {
        this.columns.forEach(column => {
          if (!column._column.visible) {
            this.$emit('toggle', column._column.field)
          }
        })
      } else {
        this.columns.forEach(column => {
          if (column._column.visible) {
            this.$emit('toggle', column._column.field)
          }
        })
      }
    }
  },
  computed: {
    strategy () {
      return this.columns.filter(column => [
        'keyword',
        'score',
        'url',
        'published_url',
        'section',
        'url_page_type',
        'url_status',
        'writing_status',
        'content_brief_status',
        'difficulty_score'
      ].includes(column._column.field))
    },
    rankingData () {
      return this.columns.filter(column => [
        'metric_rank_zone_current',
        'metric_rank',
        'rank_current_url',
        'url_match',
        'metric_rank_timestamp_current',
        'metric_rank_current',
        'rank_blur_count'
      ].includes(column._column.field))
    },
    baselineData () {
      return this.columns.filter(column => [
        'metric_rank_timestamp_baseline',
        'metric_rank_zone_baseline',
        'metric_rank_baseline',
        'rank_baseline_url'
      ].includes(column._column.field))
    },
    serpFeatures () {
      return this.columns.filter(column => [
        'answer_box',
        'brand_pack',
        'image_pack',
        'knowledge_graph',
        'local_3_pack',
        'news_pack',
        'people_also_ask',
        'related_searches',
        'shopping_box',
        'video_pack',
        'ad_count',
        'geo',
        'locale',
        'total_number_of_results'
      ].includes(column._column.field))
    },
    searchVolume () {
      return this.columns.filter(column => [
        'metric_msv_broad_adjusted_1',
        'metric_msv_broad_adjusted_2',
        'metric_msv_broad_adjusted_3',
        'metric_msv_broad_adjusted_4'
      ].includes(column._column.field))
    },
    productGrids () {
      return this.columns.filter(column => [
        'product_grids',
        'total_product_cards',
        'seller_cards'
      ].includes(column._column.field))
    }
  }
}

</script>

<style scoped lang="scss">
input[type="checkbox"] {
    cursor: pointer;
}
.ce {

    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 30px;
    }

    &__label {
      color: $rfx-dark-march;
      font-weight: 500;
    }

    &__checkbox-label:hover {
      cursor:pointer;
    }

    align-items: stretch;
    padding: 40px;

    &__label-wrapper {
      margin-top: 15px;
    }

    &__row {
      display: flex;
    }
    &__column {
      flex: 50%;
    }

    &__controls {
      margin-left: auto;
      order: 2;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_cancel {
        background-color: $rfx-medium-march;
        color: #fff;
      }
    }

}
.container {
    margin: auto;
    margin-top: 30px;
    width: 80%;
  }
</style>
